import { createSlice } from '@reduxjs/toolkit';

import type { propsLoginState } from './interfaces';

const initialState: propsLoginState = {
  loading: false,
  error: false,
  signed: false,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    loginRequest: (state) => {
      state.loading = true;
      state.error = false;
    },
    loginSuccess: (state) => {
      state.signed = true;
      state.loading = false;
    },
    loginFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    logout: () => initialState,
    clearLogin: () => initialState,
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  logout,
  clearLogin,
} = loginSlice.actions;
export default loginSlice.reducer;
